import React from 'react';
import styles from './index.module.less';

type IProps = {
    title: string;
}

const TabPartTitle: React.FC<IProps> = ({ title }) => {
    return (
        <h2 className={styles['tab-part-title']}>
            {title || 'Title'}
        </h2>
    )
}

export default React.memo(TabPartTitle);
